(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-time-series-line"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-time-series-line"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(110);

var _timeSeriesLine = __webpack_require__(91);

var _timeSeriesLine2 = _interopRequireDefault(_timeSeriesLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _timeSeriesLine2.default;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToolTip = __webpack_require__(1);
var Core = __webpack_require__(0);
var Utils = Core.Utils;
var mds_constants = Utils.colors.mds_constants;

function ToolTipMixin() {}
/**
 * To configure the tooltip template function;
 * The template outer div must be given the "tooltip-inner" class;
 * The template outer div must also be given the "tooltip-flag" class;
 * The toolTipTemplate method must accept "d" as a parameter;
 * The toolTipTemplate method must return a template string
 * @type {Function}
 */

/* private methods */

/**
 * _currentDate
 * @private
 **/
var _currentDate = null;

/**
 * @method _getCurrentDate
 * @private
 * @desc returns the current mouse coordinate date
 * @example
 * var currentDate = _getCurrentDate();
 *
 * @return {Object} Date object
**/
var _getCurrentDate = function _getCurrentDate() {
    return _currentDate;
};

/**
 * @method _setCurrentDate
 * @private
 * @param {Object} - Date object
 * @desc Expects a Date object and sets it as the current date
 * @example
 * _setCurrentDate(new Date())
 *
 * @return undefined
**/
var _setCurrentDate = function _setCurrentDate(date) {
    if (Object.prototype.toString.call(date) !== "[object Date]") {
        console.warn("Can't update date: not a date object!");
        return;
    }

    _currentDate = date;
};

/**
 * @method _generateCells
 * @param {Array} colors - color codes to style each dash per line
 * @desc  Generates the cells of the template for each line on the chart.
 * @example
 * var cells = _generateCells(["#FF0000"]);
 *
 * @return {String} Concatenated template string of the cells
**/

ToolTipMixin.prototype.generateCells = function () {
    var data = this.get("tooltipData");
    var colors = this.get("colors");
    var dottedLines = this.get("dottedLines");
    var maxWidthTextCell = 164 - Utils.string.getLongestTextStringWidth(data); // 200 max width - 10 icon with - 26 in total padding

    return data.map(function (item) {
        var line = item.name;
        var color = colors[item.index] || mds_constants["color"].black;
        var showDots = dottedLines.indexOf(line) !== -1;
        var benchmarkStyle = showDots ? "border-top:2px dotted " + color : "border-top:2px solid " + color;
        return "<div class=\"cell tooltip-row\">\n                        <div class=\"tip-cell-icon tooltip-cell\" style=\"" + benchmarkStyle + "\"> </div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\"> " + line + " </div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + item.value + "</div>\n                    </div>";
    }).join("");
};

/**
 * @method _getLineData
 * @private
 * @desc Retrieve and concatenate the line data for the given context's data manager '
 * @example
 * var lines = _getLineData();
 *
 * @return {Array} Concatenated array of line data for y1 and y2 groups
**/
var _getLineData = function _getLineData() {
    if (!this) {
        throw new Error("Context required to find line data");
    }

    var dataManager = this.get("data");
    var y1DomainDataset = this.get("y1DomainDataset");
    var lines = dataManager.get(y1DomainDataset);
    var hasY2 = this.get("y2");

    if (hasY2) {
        var y2DomainDataset = this.get("y2DomainDataset");
        lines = lines.concat(dataManager.get(y2DomainDataset));
    }

    return lines;
};

/* end private methods */

/**
 * @method updateTooltipData
 * @param {String} name
 * @param {Number} value
 * @param {Number} index
 * @desc Sets or updates data for one of the lines on the chart.
 * @example
 * this.updateTooltipData("602107", -47, 1)
 *
 * @return undefined
**/
ToolTipMixin.prototype.updateTooltipData = function (series, mouseObjects) {
    if (!series.length) {
        console.warn("Can't update data: missing information");
        return;
    }

    // sort tooltip items by the end value of series line
    series = this.sortDataByEndValue(series);

    // format tooltipData value
    var y1FormatFn = this.tickFormat(this.get("y1TickFormat"));
    var y2FormatFn = this.tickFormat(this.get("y2TickFormat"));
    var dataManager = this.get("data");

    var tooltipData = [];
    series.forEach(function (item) {
        var value = null;
        var name = item.name;
        var data = mouseObjects[name];
        if (data) {
            value = data.value;
        }
        var formatter = dataManager.inGroup(name, "y1") ? y1FormatFn : y2FormatFn;
        var formattedValue = Utils.string.convertDashToEnDash(formatter(value));
        var transformedValue = formattedValue == null || formattedValue == "" ? "N/A" : formattedValue;
        tooltipData.push({
            name: name,
            index: item.index,
            value: transformedValue
        });
    });

    this.set("tooltipData", tooltipData);
};

/**
 * @method toolTipTemplate
 * @desc Either uses the custom template added by the user or generates a default one.
 *       Used to draw the tooltip later.
 * @example
 * chart.toolTipTemplate()
 *
 *
 * @return {String} template for tooltip
**/
ToolTipMixin.prototype.toolTipTemplate = function () {
    var customTemplate = this.get("tooltipCustomTemplate");
    if (customTemplate) {
        return customTemplate;
    } else {
        var format, title;
        var cells = this.generateCells.call(this);
        var date = _getCurrentDate();

        if (date) {
            format = this.get("tooltipTimeFormat") || d3.time.format("%x");
            title = this.get("tooltipTitle") || format(date);
        } else {
            title = this.get("tooltipTitle") || "Securities";
        }

        return "<div class=\"tooltip-inner tooltip-flag\">\n                    <div class=\"tooltip-title\">\n                        <p>" + title + "</p>\n                    </div>\n\n                    <div class=\"tooltip-body tooltip-table\">\n                        " + cells + "\n                    </div>\n                </div>";
    }
};

/**
 * @method drawToolTip
 * @desc Binds the tooltip to the tooltip transparent canvas
 * @example
 * chart.drawToolTip()
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.drawToolTip = function (options) {

    this.set("showToolTip", true);

    var defaultOpts = {
        transition: false,
        namespace: this.get("id"),
        chart: "time-series"
    };

    Utils.object.copy(defaultOpts, options);

    var t = this.toolTipTemplate.bind(this);
    var tooltip = ToolTip(defaultOpts).template(t);
    var canvas = this.get("canvas");
    var svg = canvas.layer("top-layer", "front").select("rect");

    svg.call(tooltip.bind());

    this.set("tooltipInfo", tooltip);
};

/**
 * @method removeToolTip
 * @desc Removes the tooltip and the tooltip canvas
 * @example
 * chart.removeToolTip()
 *
 *
 * @return undefined
**/
ToolTipMixin.prototype.removeToolTip = function () {

    this.set("showToolTip", false);

    var canvas = this.get("canvas");
    var layer = canvas.layer("front-group");

    layer.remove();
    this.update();
};

/**
 * @method validateTooltipDirection
 * @desc Determines if the tooltip needs to change positions based on where it is on the canvas and update it.
 *
 * @param {Array} mouse - d3 selection
 * @example
 * var mouse = d3.mouse(this)
 * chart.validateTooltipDirection(mouse)
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.validateTooltipDirection = function (mouse) {
    var coords = {};
    var canvas = this.get("canvas");
    var tooltipData = this.get("tooltipData");

    coords.tooltip = this.get("tooltipInfo")._clientRect;
    coords.mouse = mouse;
    coords.canvasWidth = canvas.width();
    coords.canvasHeight = canvas.height();
    coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();

    this.getHoverLineLeft();
    this.changeToolTipDirection(coords);

    if (this.get("tooltipHidden")) {
        this.get("tooltipInfo").show(tooltipData, {
            position: this.get("direction"),
            namespace: this.get("id"),
            hoverLeft: this.get("hoverLineLeft")
        });
        this.set("tooltipHidden", false);
    }
};

/**
 * @method changeToolTipDirection
 * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
 *
 * @param {Object} coords - mouse and tooltip positional information
 * @example
 * var coords = {};
 * coords.tooltip = this.get("tooltipInfo")._clientRect;
 * coords.mouse = mouse;
 * coords.canvasWidth = canvas.width();
 * coords.canvasHeight = canvas.height();
 * coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();
 * chart.changeToolTipDirection(coords)
 *
 * @return undefined
 **/
ToolTipMixin.prototype.changeToolTipDirection = function (coords) {
    var tooltip = this.get("tooltipInfo"); //Reference to tooltip
    var canvasWidth = coords.canvasWidth; // Chart plotted width
    var canvasHeight = coords.canvasHeight; // Chart plotted height

    var hoverLineToLeft = this.get("hoverLineLeft") - coords.canvasPositioning.left; //The distance between hoverLine and left side of canvas
    var tooFarRight = coords.tooltip && coords.mouse[0] >= canvasWidth - coords.tooltip.width && hoverLineToLeft >= coords.tooltip.width; //Boolean for right canvas boundry
    var tooFarLeft = coords.tooltip && (coords.mouse[0] < canvasWidth - coords.tooltip.width ? true : hoverLineToLeft < coords.tooltip.width); //Boolean for left canvas boundry
    var tooHigh = coords.tooltip && coords.mouse[1] <= coords.tooltip.height; //Boolean for top canvas boundry
    var tooLow = coords.tooltip && coords.mouse[1] >= canvasHeight - coords.tooltip.height; //Boolean for bottom canvas boundry

    var windowtHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = coords.tooltip && coords.tooltip.height - coords.mouse[1] > coords.canvasPositioning.top; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = coords.tooltip && viewportMousePositionY + coords.tooltip.height > windowtHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    if (tooFarRight && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-bottom");
        return;
    }

    if (tooFarLeft && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-bottom");
        return;
    }

    if (tooFarRight && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-top");
        return;
    }

    if (tooFarLeft && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-top");
        return;
    }

    return;
};

/**
     * @method getHoverLineLeft
     * @desc Set the left px position of the current selected data line
     * @return undefined
**/
ToolTipMixin.prototype.getHoverLineLeft = function () {
    var canvas = this.get("canvas");
    var mouseRect = canvas.layer('front-group').select(".mouse-rect-line");
    this.set("hoverLineLeft", mouseRect[0][0].getBoundingClientRect().left);
};

/**
     * @method createMouseRect
     * @desc Create the area on the canvas that listens to mouse events for the tooltip
     *
     * @example
     * chart.this.createMouseRect();
     *
     *
     * @return undefined
    **/
ToolTipMixin.prototype.createMouseRect = function () {
    var _this = this;
    var canvas = this.get("canvas");
    var scales = this.get("scales");

    var yPadding = this.get("yPadding");
    var width = canvas.width() - yPadding * 2;
    var height = canvas.height();
    var topLayer = canvas.layer("top-layer", "front");
    var x = scales.scale("x");
    var rectMouse = topLayer.append("rect"); // append a rect to catch mouse movements on canvas

    rectMouse.attr("x", yPadding).attr("width", width).attr("height", height).attr("fill", "none").attr("pointer-events", "all").classed({
        "rect__event-area": true
    }).on("mouseleave", function () {
        // on mouse leave hide line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "0");

        var agileStyle = _this.get("agileStyle");
        if (!agileStyle.bubbleOpacity) {
            var layer = canvas.layer("line-chart-layer");
            layer.selectAll(".line-bubbles").attr("opacity", 0);
        }
    }).on("mouseover", function () {
        // on mouse in show line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "1");
    }).on("mousemove", function () {
        // mouse moving over canvas
        var frontGroup = canvas.layer('front-group');
        var mouse = d3.mouse(this);

        var seriesData = [];
        var series = [];
        // build seriesData at the same time when get translate
        frontGroup.selectAll(".mouse-per-line").attr("transform", function (d) {
            seriesData = seriesData.concat(d.series);
            series.push({
                name: d.displayName,
                index: d.index,
                value: _this.getValidEndValue(d.series)
            });
            return "translate(" + mouse[0] + "," + mouse[1] + ")";
        });

        // sort all seriesData by date
        seriesData.sort(function (a, b) {
            return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
        });

        var xDate = x.invert(mouse[0]);
        var bisect = d3.bisector(function (d) {
            return d.date;
        }).right;
        var idx = bisect(seriesData, xDate) - 1;
        idx = idx >= seriesData.length ? seriesData.length - 1 : idx;
        idx = idx < 0 ? 0 : idx;
        // find out the date at which mouse place, it will be used in the following
        var mouseDate = seriesData[idx].date;

        // find out items at the mouseDate,
        // Notice: if a series have no data on the day, mouseItems will not catains this series data
        // this is why we need seriesNames to record whole series
        var mouseItems = seriesData.filter(function (item) {
            return item.date.toString() === mouseDate.toString();
        });
        // convert to a object to make data more easy to be found
        var mouseObjects = {};
        mouseItems.forEach(function (item) {
            mouseObjects[item.name] = item;
        });

        /**
         * make sure tooltip use this data
         */
        _this.updateTooltipData(series, mouseObjects);

        /**
         * snap scrubber line to relevant hover data point
         */
        frontGroup.select(".mouse-rect-line").attr("d", function () {
            var d = "M" + x(mouseDate) + "," + height;
            d += " " + x(mouseDate) + "," + 0;
            return d;
        });

        _setCurrentDate(mouseDate);
        _this.validateTooltipDirection(mouse);
        _this.handleAgileStyle(mouseDate);
    }); //end mousemove
};

/**
* @method handleAgileStyle
* @desc Display bubbles which has the same date as mouseDate, hide other bubbles.
* @param {Date} mouseDate: the closest calculated date with mouse position
*/
ToolTipMixin.prototype.handleAgileStyle = function (mouseDate) {
    var agileStyle = this.get("agileStyle");
    if (!agileStyle.bubbleOpacity) {
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        layer.selectAll(".line-bubbles").attr("opacity", 0);
        layer.selectAll(".line-bubbles.date" + mouseDate.getTime()).attr("opacity", 1);
    }
};

/**
 * @method renderToolTip
 * @desc Takes all the necessary steps to display the tooltip flag as long as the proper conditions are met
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.renderToolTip = function () {
    if (this.get("showToolTip") && !this.get("initialized")) {
        this.set("tooltipData", []);
        this.set("tooltipHidden", true); //initializes the property used to show tooltip
        this.createTooltip();
        this.drawToolTip({
            namespace: this.get("id")
        });
        this.set("direction", "right-top");
        this.set("initialized", true);
    }
};

/**
 * @method createTooltip
 * @desc Takes each line of the chart and calculates necessary tooltip data including timestamp, value, and name
 *       depending on where the mouse is on the canvas.
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.createTooltip = function () {
    var canvas = this.get("canvas");
    var lineData = _getLineData.bind(this);

    var layer = canvas.layer("front-group");

    var mouseG = layer.append("g").attr("class", "mouse-over-effects");

    mouseG.append("path") // this is the black vertical line to follow mouse
    .attr("class", "mouse-rect-line").style("stroke", "black").style("stroke-width", "1px").style("stroke-dasharray", "3,3").style("opacity", "0").style("pointer-events", "all");

    var mousePerLine = mouseG.selectAll(".mouse-per-line").data(lineData);

    mousePerLine.attr("class", "mouse-per-line");

    mousePerLine.enter().append("g").attr("class", "mouse-per-line");

    mousePerLine.exit().remove();

    this.createMouseRect();
};

module.exports = ToolTipMixin;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var YEAR_FORMAT = "%Y";

/**
 * Ticks period configuration. '_sm' suffix stands for small screens (breakpoint).
 */
var TICKS_DEF = {
    year: [d3.time.years, 1],
    year_sm: [d3.time.years, 2],
    year_at_15: [d3.time.years, 2],
    year_at_15_sm: [d3.time.years, 3],
    year_at_30: [d3.time.years, 3],
    year_at_30_sm: [d3.time.years, 5],
    year_at_45: [d3.time.years, 5],
    year_at_45_sm: [d3.time.years, 10],
    year_at_60: [d3.time.years, 10],
    year_at_60_sm: [d3.time.years, 15],
    quarter: [d3.time.months, 3],
    quarter_sm: [d3.time.months, 6],
    month: [d3.time.months, 1],
    month_sm: [d3.time.months, 2],
    week: [d3.time.weeks, 1],
    week_sm: [d3.time.weeks, 2],
    day: [d3.time.days, 1],
    day_sm: [d3.time.days, 2],
    hour: [d3.time.hours, 4],
    hour_sm: [d3.time.hours, 4]
};

/**
 * Map that holds the timeline sub level for each period.
 */
var LEVEL_MAPPER = {
    year: "year",
    quarter: "quarter",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour"
};

/**
 * Returns the tick period parameters for a given period and screen type.
 * @param {*} period
 * @param {*} smallScreen
 * @returns {Array} Array that holds the tick configuration for the x axis label.
 */
var getTickParameters = function getTickParameters(period, smallScreen) {
    period = period + (smallScreen ? "_sm" : "");
    return TICKS_DEF[period];
};

function Helper() {}

/**
 * Returns an array that contains the years within the domain.
 * @method getYear
 * @param {Array} domain
 * @returns {Array}
 */
var getYear = function getYear(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var yr = Math.floor(date.getFullYear());
    newDate.setYear(++yr);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        yr = Math.floor(newDate.getFullYear());
        newDate.setYear(++yr);
    }
    return dateArr;
};

/**
 * Returns an array that contains the quarters within the domain.
 * @method getQuarter
 * @param {Array} domain
 * @returns {Array}
 */
var getQuarter = function getQuarter(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var qtr = Math.floor(date.getMonth() / 3);
    newDate.setMonth(++qtr * 3);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        qtr = Math.floor(newDate.getMonth() / 3);
        newDate.setMonth(++qtr * 3);
    }
    return dateArr;
};

/**
 * Returns an array that contains the months within the domain.
 * @method getMonth
 * @param {Array} domain
 * @returns {Array}
 */
var getMonth = function getMonth(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextMonth = date.getMonth() + 1;
    newDate.setMonth(nextMonth);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextMonth = newDate.getMonth() + 1;
        newDate.setMonth(nextMonth);
    }

    return dateArr;
};

/**
 * Returns the next week first day.
 * @param {Date} date
 * @returns {Date}
 */
var getNextWeekStartDate = function getNextWeekStartDate(date) {
    var newDate = new Date(date.toString());
    var day = newDate.getDate();
    var weekDay = newDate.getDay();
    newDate.setDate(day + (7 - weekDay));
    return newDate;
};

/**
 * Returns an array that contains the weeks within the domain.
 * @method getWeek
 * @param {Array} domain
 * @returns {Array}
 */
var getWeek = function getWeek(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = getNextWeekStartDate(date);
    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = getNextWeekStartDate(newDate);
    }

    return dateArr;
};

/**
 * Returns an array that contains the days within the domain.
 * @method getDay
 * @param {Array} domain
 * @returns {Array}
 */
var getDay = function getDay(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextDay = date.getDate() + 1;
    newDate.setDate(nextDay);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextDay = newDate.getDate() + 1;
        newDate.setDate(nextDay);
    }

    return dateArr;
};

/**
 * Returns an array that contains the hours within the domain.
 * @method getHour
 * @param {Array} domain
 * @returns {Array}
 */
var getHour = function getHour(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextHour = date.getHours() + 1;
    newDate.setHours(nextHour);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextHour = newDate.getHours() + 1;
        newDate.setHours(nextHour);
    }

    return dateArr;
};

/**
 * Gets the first visible tick from the ticks array.
 * @param {D3 Selection} allTicks Must contain a selection of ticks. Required.
 * @returns {D3 Selection}
 */
var getNextVisible = function getNextVisible(allTicks) {
    var next;
    allTicks.each(function () {
        var el = d3.select(this);
        if (!next && el.style("display") !== "none") {
            next = el;
        }
    });

    return next || d3.select();
};

/**
 * Used to make the domain symmetrical bc line chart doesn't use calculateDomain method in Core
 * @method makeSymmetrical
 * @param {Array} domain containing min and max values
 */
Helper.prototype.makeSymmetrical = function (arr) {
    var p0 = arr[0] < 0 ? arr[0] * -1 : arr[0];
    var p1 = arr[1] < 1 ? arr[1] * -1 : arr[1];

    if (p0 > p1) {
        return [p0 * -1, p0];
    } else {
        return [p1 * -1, p1];
    }
},

/**
 * Sets the x axis ticks funtion depending on the timeline level.
 * @method helperSetTicks
 * @param {Boolean} smallScreen
 */
Helper.prototype.helperSetTicks = function (smallScreen) {
    var timelineLevel = this.get("timelineLevel");

    var xDomain = this.get("xDomain");
    if (xDomain) {
        var dateDiff = xDomain[1].getFullYear() - xDomain[0].getFullYear();
        if (dateDiff > 14) {
            if (dateDiff < 29) timelineLevel = 'year_at_15';else if (dateDiff < 44) timelineLevel = 'year_at_30';else if (dateDiff < 59) timelineLevel = 'year_at_45';else timelineLevel = 'year_at_60';
        }
    }
    var xTicks = getTickParameters(timelineLevel, smallScreen);

    var subLabelFormat = YEAR_FORMAT;

    this.set("_xTicks", xTicks);
    this.set("subLabelFormat", subLabelFormat);
};

/**
 * Sets the x axis sub labels array.
 * @method helperSetSublabels
 */
Helper.prototype.helperSetSublabels = function () {
    var axes = this.get("canvas").get("axesGroup");
    var xDomain = this.get("xDomain");
    var subLabelFormat = this.get("subLabelFormat") || "%Y";

    var ticks = [];
    var subLabels = [];
    var previous = d3.time.format(subLabelFormat)(xDomain[0]);

    axes.selectAll(".mbc-axis-x .tick").each(function (d) {
        ticks.push(d);
    });

    ticks.forEach(function (tick) {
        var formatted = d3.time.format(subLabelFormat)(tick);
        if (previous === formatted) {
            subLabels.push(null);
        } else {
            subLabels.push(formatted);
            previous = formatted;
        }
    });

    this.set("xSubLabels", subLabels);
};

/**
 * Adds the first and last date x axes ticks.
 * @method helperAddFirstLabel
 * @param {Canvas} canvas Canvas containing the chart.
 */
Helper.prototype.helperAddFirstLabel = function (canvas) {

    var xDomain = this.get("xDomain");
    var subLabelFormat = d3.time.format(this.get("subLabelFormat") || YEAR_FORMAT);
    var yPadding = this.get("yPadding");
    var xTickFormat = this.get("_xTickFormat");
    var axes = canvas.get("axesGroup").select(".mbc-axis-x");
    var xAxisOrient = this.get("xAxisOrient");
    var xScale = this.get("scales").scale("x");
    var allTicks, firstTick, lastTick, tick, tickLast, firstRect, lastRect, tickRect, x, showLastSublabel, lastSublabel, diff;

    axes.selectAll("g.artificial").remove();
    allTicks = axes.selectAll(".tick").filter(function () {
        return !d3.select(this).classed("artificial");
    }).style("display", "");

    firstTick = getNextVisible(allTicks); //allTicks.first();
    lastTick = allTicks.last();

    // First one
    tick = axes.append("g").classed({
        tick: true,
        artificial: true,
        first: true
    }).attr("transform", "translate(0, 0)");

    tick.append("text").attrs({
        x: yPadding,
        y: xAxisOrient === "bottom" ? 3 : -3,
        "text-anchor": "start",
        dy: xAxisOrient === "bottom" ? ".71em" : "0em"
    }).text(xTickFormat(xDomain[0]));
    tick.append("text").text(subLabelFormat(xDomain[0])).attr("transform", function () {
        var y = xAxisOrient === "bottom" ? 28 : -18;
        return "translate(" + yPadding + ", " + y + ")";
    }).attr("class", "mbc-tick-abbreviation");

    if (!firstTick.empty()) {
        firstRect = firstTick.node().getBoundingClientRect();
        tickRect = tick.node().getBoundingClientRect();

        if (Math.abs(firstRect.left - tickRect.left) < tickRect.width + 10) {
            firstTick.style("display", "none");
        }
    }

    // Last Tick
    if (!lastTick.empty()) {
        lastRect = lastTick.node().getBoundingClientRect();
        x = canvas.width() - yPadding * 2;

        tickLast = axes.append("g").classed({
            tick: true,
            artificial: true,
            last: true
        }).attr("transform", "translate(" + x + ", 0)");

        tickLast.append("text").attrs({
            x: yPadding,
            y: xAxisOrient === "bottom" ? 3 : -3,
            "text-anchor": "end",
            dy: xAxisOrient === "bottom" ? ".71em" : "0em",
            class: "mbc-tick-label"
        }).text(xTickFormat(xDomain[1]));

        lastSublabel = tickLast.append("text").text(subLabelFormat(xDomain[1])).attrs({
            class: "mbc-tick-abbreviation",
            "text-anchor": "end",
            transform: function transform() {
                var y = xAxisOrient === "bottom" ? 28 : -18;
                return "translate(" + yPadding + ", " + y + ")";
            }
        });

        diff = tickLast.select(".mbc-tick-label").node().getBoundingClientRect().width - tickLast.select(".mbc-tick-abbreviation").node().getBoundingClientRect().width - 1;

        lastSublabel.attr("dx", diff * -1 + "px");

        tickRect = tickLast.node().getBoundingClientRect();

        showLastSublabel = lastTick[0][0].__data__.getYear() !== xDomain[1].getYear();
        if (xScale(lastTick[0][0].__data__) + lastRect.width - 2 > canvas.width() - yPadding) {
            lastTick.style("display", "none");
            showLastSublabel = lastTick[0][0].previousSibling && lastTick[0][0].previousSibling.__data__.getYear() !== xDomain[1].getYear();
        }

        if (!showLastSublabel) {
            lastSublabel.style("display", "none");
        } else {
            lastSublabel.style("display", "");
        }

        tickLast.style("display", "none");
    }
};

/**
 *
 * @method helperGetBackgroundArray
 * @param {Array} domain Chart domain.
 * @param {String} period Time period to generate the array for the background.
 * @returns {Array} Array containing the dates for each period within the domain.
 */
Helper.prototype.helperGetBackgroundArray = function (domain) {
    var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quarter";

    var datesArray;
    switch (period) {
        case "year":
            datesArray = getYear(domain);
            break;
        case "quarter":
            datesArray = getQuarter(domain);
            break;
        case "month":
            datesArray = getMonth(domain);
            break;
        case "week":
            datesArray = getWeek(domain);
            break;
        case "day":
            datesArray = getDay(domain);
            break;
        case "hour":
            datesArray = getHour(domain);
            break;
        default:
            break;
    }
    return datesArray;
};

/**
 * @method helperXBuffer
 * @desc set buffer for xAxis
 * @param {Date} original - original date to be buffered
 * @param {Object} options - options for how much to buffer
 * @example
 *  this.helperXBuffer(new Date(), {level: 'hour', amount: 5})
 *
 * @return {Date} buffered date object
 */
Helper.prototype.helperXBuffer = function (original, options) {
    var level = LEVEL_MAPPER[options.level];
    var buffered;

    if (typeof d3.time[level] === "function") {
        buffered = d3.time[level].offset(original, options.amount);
    }

    return (typeof buffered === "undefined" ? "undefined" : _typeof(buffered)) === "object" ? buffered : original;
};

/**
 * @method sortDataByEndValue
 * @desc sort data by series end value
 * @example {Array} data
 *  [{name: "name", index: "2", endValue: 1345.002}, ...]
 * @return {Array} data
 */
Helper.prototype.sortDataByEndValue = function (data) {
    // tooltip items' order, legend items' order
    var linesOrder = this.get("linesOrder");
    data.sort(function (a, b) {
        var value = b.value - a.value;
        if (linesOrder === 'asc') {
            return -value;
        } else if (linesOrder === 'desc') {
            return value;
        } else {
            return 0;
        }
    });

    return data;
};

/**
 * @method getValidEndValue
 * @desc get valid end value of lines
 * @param {Array} series
 */
Helper.prototype.getValidEndValue = function (series) {
    var endValue;
    if (!series || !(series instanceof Array && series.length)) {
        return;
    }
    for (var i = series.length - 1; i >= 0; i--) {
        var value = series[i].value;
        if (value != null) {
            endValue = value;
            break;
        }
    }
    return endValue;
};

module.exports = Helper;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Core = __webpack_require__(0);
var Legend = __webpack_require__(2);
var Tooltip = __webpack_require__(89);
var Helper = __webpack_require__(90);

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;

/**
 * Time Series Line Chart.
 *
 * @example
 * // Extension example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var newExtendedTimeSeriesLineChart = TimeSeriesLineChart.extend({
 *   ...
 * });
 *
 * @examples
 * // Use example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var timeSeries = new TimeSeriesLineChart(<options>);
 * d3Container.datum(data).call(timeSeries.init());
 *
 * @class
 * @extends Chart
 */
var TimeSeriesLineChart = Chart.extend(Helper, Legend, Tooltip,
/**
 * @lends TimeSeriesLineChart.prototype
 **/
{
    id: "mbc-time-series-line-chart", // Also used as class for this chart type.
    /** @type {Number} */
    screenMinHeight: 100, // container min-height
    breakpoint: 650,
    smallBreakpoint: 400,
    legend: true,
    legendMaxWidth: 150,
    legendPosition: "right",
    ticksNumber: 4,
    tickValues: null,
    xAxisOrient: "bottom",
    xDomain: null,
    xDomainDataset: "x",
    y1DomainDataset: "y1",
    y2DomainDataset: "y2",
    y1Abbreviation: null,
    y1AxisLabel: false,
    y1AxisOrient: "left",
    y1TickValues: null,
    y1TicksAlign: "right",
    y1TickFormat: ",.2f",
    y1TickSymbol: "$",
    y1Bubbled: false,
    y1Symmetrical: false,
    y2Abbreviation: null,
    y2AxisLabel: false,
    y2AxisOrient: "left",
    y2TickValues: null,
    y2TicksAlign: "right",
    y2TickFormat: ",.2f",
    y2TickSymbol: "$",
    y2Bubbled: false,
    y2Symmetrical: false,
    lineStrokeWidth: 2,
    dottedDashDimensions: "1, 5",
    bubbleRadius: 4,
    bubbleStrokeWidth: 2,
    yAxesLabelWidth: 20,
    yAxesLabelPadding: 6,
    yAxesSpacing: 5,
    yDomain: null,
    yPadding: 12,
    yPaddingBig: 12,
    yPaddingSmall: 6,
    yTickMargin: 6,
    yTickSize: 35,
    xTickFormat: null,
    xTicks: null, // Optional now and exclusive with timelineLevel for legacy
    xTickSize: null,
    showLegendValues: false, // Boolean
    greyBandLevel: null,
    timelineLevel: null, // year, quarter, month, week, day. Exclusive with xTicks
    firstTickDate: true, // true or false
    xAxisBuffer: null, // Optional Object
    xAxisStart: null, //Optional Date Object
    xAxisEnd: null, // Optional Date Object
    legendValueFont: "bold 18px helvetica neue",
    legendLabelFont: "14px helvetica neue",
    linesOrder: null, // asc/desc/null, will be used to sort the items order in legend and tooltip by the end value of series line
    dottedLines: [], //set dotted line key, such as ['line1Key','line2Key']
    /**
     * Prepare the data for the chart.
     * @method setData
     * @param {Object} data
     */
    setData: function setData(data) {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;

        /* set up lines in y1 and y2 groups */
        var y1Lines = d3.nest().key(function (d) {
            return d.name;
        }).entries(data[y1DomainDataset]);

        y1Lines.forEach(function (line) {
            line.values.forEach(function (segment) {
                if (parseFormat && _typeof(segment.date) !== "object") {
                    segment.date = parseFormat(segment.date);
                }
            });

            dataManager.set(line.key, line.values, y1DomainDataset);
        });

        if (this.get("y2")) {
            var y2Lines = d3.nest().key(function (d) {
                return d.name;
            }).entries(data[y2DomainDataset]);

            y2Lines.forEach(function (line) {
                line.values.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                dataManager.set(line.key, line.values, y2DomainDataset);
            });
        }

        this.setParsers();
    },
    /**
     * @method checkForDataIslands
     * @param {Array} data
     * @param {String} yAxis
     * @desc Determine if dataset includes any datapoints surrounded by null or undefined values
     * @return undefined
     */
    checkForDataIslands: function checkForDataIslands(data, yAxis) {
        var hasIslands = false;
        var indexes = [];
        var vals = data[0].series;
        for (var i = 0; i < vals.length; i++) {
            var lastVal = vals[i - 1] ? vals[i - 1].value : null,
                // vals[0-1] === undefined
            nextVal = vals[i + 1] ? vals[i + 1].value : null; // vals[(vals.length-1)+1] === undefined
            if (vals[i].value != null && lastVal == null && nextVal == null) {
                indexes.push(i);
                hasIslands = true;
            }
        }

        if (hasIslands) {
            this.drawIslandBubbles(data, indexes, yAxis);
        }
    },
    /**
     * @method drawIslandBubbles
     * @param {Array} data
     * @param {Array} indexes
     * @param {String} yAxis
     * @desc Render bubble dots for datapoints that are islands, i.e., surrounded by null or undefined values
     * @return undefined
     */
    drawIslandBubbles: function drawIslandBubbles(data, indexes, yAxis) {

        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale(yAxis);
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get("agileStyle");
        var bubbles;

        data.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method setParsers
     * @desc Set default or user-specific parsers for datasets
     * @example
     * chart.setParsers()
     *
     *
     * @return undefined
     */
    setParsers: function setParsers() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;
        var y1Parser = this.get("y1Parser");
        var y2Parser = this.get("y2Parser");
        var useDefaultParsers = this.get("useDefaultParsers");
        var y2 = this.get("y2");

        var defaultParser = function defaultParser(data) {

            var map = data.map(function (line) {
                line.series.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                var sorted = line.series.sort(function (a, b) {
                    return a.date - b.date;
                });

                line.series = sorted;
                return line;
            });

            return map;
        };

        if (useDefaultParsers) {
            dataManager.parser(y1DomainDataset, defaultParser);
            dataManager.parser(y2DomainDataset, defaultParser);
        }

        if (y1Parser && !useDefaultParsers) {
            dataManager.parser(y1DomainDataset, y1Parser.bind(this));
        }

        if (y2 && y2Parser && !useDefaultParsers) {
            dataManager.parser(y2DomainDataset, y2Parser.bind(this));
        }
    },

    /**
     * @override
     * Set the tickSize, axesSpacing, padding, and margin
     */
    beforeDraw: function beforeDraw() {
        this.redoCanvas();
        this.checkBreakpoints();
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var xTicks = this.get("xTicks");
        var xTickFormat = this.get("xTickFormat");
        var smallScreen = canvas.get("outerWidth") <= this.get("breakpoint");

        if (!y1LabelText && !y2LabelText) {
            canvas.set("yAxesLabelWidth", 0);
        } else {
            canvas.set("yAxesLabelWidth", yAxesLabelWidth);
        }

        canvas.set("tickSize", this.get("yTickSize"));
        canvas.set("axesSpacing", this.get("yAxesSpacing"));
        canvas.set("margin", this.getMargins());

        if (!this.get("y2")) {
            this.get("axes").remove("y2");
        }

        if (smallScreen) {
            this.set("yPadding", this.get("yPaddingSmall"));
        } else {
            this.set("yPadding", this.get("yPaddingBig"));
        }

        // xTicks Legacy
        if (xTicks) {
            this.set("_xTicks", xTicks); // Private variable
        } else {
            if (!this.get("timelineLevel")) {
                this.set("timelineLevel", "year");
            }

            this.helperSetTicks(smallScreen);
        }

        if (!xTickFormat && !xTicks) {
            this.set("_xTickFormat", d3.time.format("%Y"));
        }

        if (!xTickFormat && this.get("timelineLevel")) {
            this.set("_xTickFormat", d3.time.format("%b %e"));
        } else {
            this.set("_xTickFormat", xTickFormat);
        }

        if (this.get("legend")) {
            this.invokeLegend({
                chart: "time-series",
                data: this.get('data')._data,
                mouseover: false
            });
        }
    },

    /**
     * @override
     * Visual adjustments after the chart has been rendered
     */
    afterDraw: function afterDraw(options) {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var noTicksRecalc = options && options.noTicksRecalc;
        var tinyScreen = canvas.get("outerWidth") <= this.get("smallBreakpoint");
        var xSubLabels = this.get("xSubLabels");
        var xOriginalTicks, lastTick;
        var showLegend = this.get("legend");

        this.adjustYLabels();

        var xTicks = axes.selectAll("." + Classes.AXIS + "-x text");

        xTicks.style("text-anchor", "start");

        if (showLegend) {
            canvas.watch("outerWidth", function (newValue, oldValue) {
                this.checkBreakpoints(newValue, oldValue);
            }.bind(this));
        }

        if (!noTicksRecalc) {
            this.updateTickWidths();
        }
        if (this.get("timelineLevel") && this.get("firstTickDate")) {
            this.helperAddFirstLabel(canvas);
        }

        if (Array.isArray(xSubLabels) && xSubLabels.length || this.get("timelineLevel")) {
            this.appendAxisSubLabels();
        }

        lastTick = axes.select("." + Classes.AXIS + "-x g.tick.last");
        if (tinyScreen) {
            xOriginalTicks = axes.selectAll("." + Classes.AXIS + "-x g.tick").filter(function () {
                return !d3.select(this).classed("artificial");
            });

            xOriginalTicks.style("opacity", 0);
            lastTick.style("display", "inline");
        } else {
            lastTick.style("display", "none");
        }

        this.renderToolTip();

        if (this.get("legend")) {
            this.adjustLegendHeight();
        }
    },

    /**
     * @method appendAxisSubLabels
     * @desc Appends axis Sub Labels
     */
    appendAxisSubLabels: function appendAxisSubLabels() {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var xAxis = axes.selectAll("." + Classes.AXIS + "-x g.tick");
        var xSubLabels = this.get("xSubLabels");
        var xAxisOrient = this.get("xAxisOrient");

        xAxis[0].forEach(function (tick, idx) {
            if (xSubLabels[idx]) {
                d3.select(tick).append("text").text(function () {
                    return xSubLabels[idx];
                }).attr("transform", function () {
                    var y = xAxisOrient === "bottom" ? 28 : -18;
                    return "translate(0, " + y + ")";
                }).attr("class", "mbc-tick-abbreviation");
            }
        });
    },

    /**
     * @method updateTickWidths
     * @desc calculate and update the y axis tick width
     * @example
     *
     * chart.updateTickWidths()
     *
     *
     * @return undefined
     */
    updateTickWidths: function updateTickWidths() {
        var maxWidth = 0;
        var ticks = [];
        var el;

        d3.selectAll(".mbc-axis.mbc-axis-y1 .tick text").each(function () {
            el = d3.select(this);
            ticks.push(el.text());
        });
        maxWidth = Utils.svg.getGreaterSVGTextWidth(this.get("canvas").get("svg"), ticks);
        this.set("yTickSize", maxWidth + this.get("yTickMargin"));
        this.set("ticksUpdated", true);
        this.update({ noTicksRecalc: true });
    },

    /**
     * @override
     * @method draw
     */
    draw: function draw() {
        this.buildScales();
        this.buildAxes();
        this.drawAxes();
        this.drawLines();
        this.drawBubbles();
        this.drawBackgroundBars();
        this.drawGrid();
        this.drawClipPath();

        if (this.get("timelineLevel")) {
            this.helperSetSublabels();
        }
    },

    /**
     * @method drawLines
     * @desc Graph the lines onto the chart for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawLines()
     *
     * @return undefined
     */
    drawLines: function drawLines() {
        var _this = this;
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var y2Scale = scales.scale("y2");
        var isY2 = false;
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.calculateAgileStyle();

        var generateLine = d3.svg.line().defined(function (d) {
            return d.value != null;
        }).x(function (d) {
            return xScale(d.date);
        }).y(function (d) {
            return isY2 === false ? yScale(d.value) - 1 : y2Scale(d.value) - 1; // compensate for line thickness
        }).interpolate("linear");

        var y1DomainDataset = this.get("y1DomainDataset");

        //clear old lines on update
        var y1Lines = layer.selectAll("path").filter(".y1").data(dataManager.get(y1DomainDataset));
        this.checkForDataIslands(dataManager.get(y1DomainDataset), "y1");

        y1Lines.classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? "round" : null;
        }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

        y1Lines.enter().append("path").classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? "round" : null;
        }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

        y1Lines.exit().remove();

        if (this.get("y2")) {
            isY2 = true;
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2Lines = layer.selectAll("path").filter(".y2").data(dataManager.get(y2DomainDataset));

            this.checkForDataIslands(dataManager.get(y2DomainDataset), "y2");

            y2Lines.classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

            y2Lines.enter().append("path").classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? "round" : null;
            }).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

            y2Lines.exit().remove();
        }
    },

    /**
    * @method calculateAgileStyle
    * @desc Calculate agile style for chart based on container size
    * @return {Object} the agile style for chart.
    */
    calculateAgileStyle: function calculateAgileStyle() {
        var xScale = this.get("scales").scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var tickArr;
        if (bandLevel) {
            tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
        } else {
            tickArr = xScale.ticks.apply(this, this.get("_xTicks"));
        }

        var bubbleSpacing = (this.get("canvas").get('width') - yPadding) / tickArr.length;

        var bubbleRadius = this.get("bubbleRadius"); // default: 4
        var lineStrokeWidth = this.get("lineStrokeWidth"); // default: 2
        var bubbleStrokeWidth = this.get("bubbleStrokeWidth"); // default: 2
        var dottedDashDimensions = this.get("dottedDashDimensions"); // default: "1, 5"

        var showBigBubbleMinWidth = 2 * (bubbleRadius + 4); // 4px: dot marging
        var showSmallBubbleMinWidth = 2 * (bubbleRadius / 2 + 2); // 2px: dot marging

        var agileStyle;
        if (bubbleSpacing >= showBigBubbleMinWidth) {
            agileStyle = {
                dottedDashDimensions: dottedDashDimensions,
                lineStrokeWidth: lineStrokeWidth,
                bubbleRadius: bubbleRadius,
                bubbleStrokeWidth: bubbleStrokeWidth,
                bubbleHeight: bubbleRadius,
                bubbleOpacity: 1
            };
        } else if (bubbleSpacing >= showSmallBubbleMinWidth) {
            agileStyle = {
                dottedDashDimensions: "1, 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 1
            };
        } else {
            agileStyle = {
                dottedDashDimensions: "1, 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 0
            };
        }
        this.set("agileStyle", agileStyle);
        return agileStyle;
    },

    /**
     * @method drawBubbles
     * @desc Graph the bubbles onto the line for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawBubbles()
     *
     * @return undefined
     */
    drawBubbles: function drawBubbles() {
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var y1Bubbled = this.get("y1Bubbled");
        var y2Bubbled = this.get("y2Bubbled");

        if (y1Bubbled) {
            var y1DomainDataset = this.get("y1DomainDataset");
            var y1LinesData = dataManager.get(y1DomainDataset);
            var yScale = scales.scale("y1");
            this.generateBubbles(y1LinesData, yScale);
        }

        if (this.get("y2") && y2Bubbled) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2LinesData = dataManager.get(y2DomainDataset);
            var y2Scale = scales.scale("y2");
            this.generateBubbles(y2LinesData, y2Scale);
        }
    },

    /**
     * @method generateBubbles
     * @param   {Object} linesData
     * @param   {Function} yScale
     * @desc Render the bubble dots for each datapoint
     * @return undefined
     */
    generateBubbles: function generateBubbles(linesData, yScale) {
        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var canvas = this.get("canvas");
        var clipPathId = this.get("clipPathId", clipPathId);
        var layer = canvas.layer("line-chart-layer").attr("clip-path", "url(#" + clipPathId + ")");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get('agileStyle');
        var bubbles;
        linesData.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method drawAxes
     * @desc Call on the canvas to draw the axes and calls to build the labels
     * @example
     *
     * chart.drawAxes()
     *
     * @return undefined
     */
    drawAxes: function drawAxes() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");

        canvas.drawAxes(axes);
        this.drawAxesLabels();
    },

    /**
     * @method drawAxesLabels
     * @desc Invoke the appendLabel method with the label text set in config and the correct axis layer
     *
     * chart.drawAxesLabels()
     *
     * @return undefined
     */
    drawAxesLabels: function drawAxesLabels() {
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");

        canvas.layer(Classes.AXES + "-labels").remove();

        var layer = canvas.layer(Classes.AXES + "-labels");
        var y1Orient = this.get("y1AxisOrient");
        var y2Orient = this.get("y2AxisOrient");
        var containerTop = d3.select(".mbc-chart-legend.mbc-chart-legend-top");
        var innerContainerRight = d3.select(".mbc-chart-legend-right-inner-div");
        var oneRight = (y1Orient === "right" || y2Orient === "right") && (y1Orient !== "right" || y2Orient !== "right");
        var zeroRight = y1Orient !== "right" && y2Orient !== "right";
        var twoRight = y1Orient === "right" && y2Orient === "right";

        if (y1LabelText) {
            this.appendYLabel(layer, "y1", y1LabelText);
        }

        if (this.get("y2") && y2LabelText) {
            this.appendYLabel(layer, "y2", y2LabelText);
        }

        if (y1LabelText || y2LabelText) {
            if (zeroRight || oneRight) {
                containerTop.style("margin-left", "20px");
            }
        }

        if (oneRight || twoRight) {
            innerContainerRight.style("margin-left", "12px");
        }
    },

    /**
     * @method drawGrid
     * @desc Draw the grid lines with the y axis ticks
     * @example
     *
     * chart.drawGrid()
     *
     * @return undefined
     */
    drawGrid: function drawGrid() {
        var scales = this.get("scales");
        var y1Scale = scales.scale("y1");
        var y1Axis = this.get("axes").axis("y1");
        var yPadding = this.get("yPadding");
        var canvas = this.get("canvas");
        var tickValues = y1Axis.tickValues();
        var backGroup = canvas.get("backGroup");
        var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
        var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");

        var extractor = function extractor(d) {
            return y1Scale(d);
        };

        grid.enter().append("line").attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            class: function _class(d, i) {
                var appendClass = "";
                if (i === 0) {
                    appendClass = "first";
                }
                if (i === tickValues.length - 1) {
                    appendClass = "last";
                }
                return Classes.GRID_LINE + " " + appendClass;
            },
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.exit().remove();
    },

    /**
     * @method drawClipPath
     * @desc Chart svg includes clipping layer, clips lines and bubbles at edge of chart area
     * @example
     *
     * chart.drawClipPath()
     *
     * @return undefined
     */
    drawClipPath: function drawClipPath() {
        var canvas = this.get("canvas");
        var svg = canvas.get("svg");
        var layer = svg.select("." + Classes.BACK);
        var layerBBox = layer.node().getBBox();
        var clipPathId = this.get("clipPathId");
        svg.insert("defs", ":first-child").append("clipPath").attr("id", clipPathId).append("rect").attr({
            x: layerBBox.x,
            y: layerBBox.y,
            width: layerBBox.width,
            height: layerBBox.height
        });
    },

    /**
     * @method drawBackgroundBars
     * @desc Draw the alternating background bars that follow the x-axis ticks on the grid
     * @example
     *
     * chart.drawBackgroundBars()
     *
     * @return undefined
     */
    drawBackgroundBars: function drawBackgroundBars() {
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var backGroup = canvas.get("backGroup");
        var xScale = scales.scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var tickArr;

        if (bandLevel) {
            tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
        } else {
            tickArr = xScale.ticks.apply(this, this.get("_xTicks"));
        }

        var bars = backGroup.selectAll("rect").data(tickArr);
        var fnWidth = function fnWidth(d, i) {
            if (i + 1 === tickArr.length) {
                return canvas.width() - yPadding - xScale(tickArr[i]);
            } else {
                return xScale(tickArr[i + 1]) - xScale(tickArr[i]);
            }
        };

        // Update Selection
        bars.attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Enter Selection
        bars.enter().append("rect").attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Exit Selection
        bars.exit().remove();
    },

    /**
     * @method buildAxes
     * @desc Build all of the axes
     * @example
     *
     * chart.buildAxes()
     *
     * @return undefined
     */
    buildAxes: function buildAxes() {
        var _this = this;
        var scales = this.get("scales");
        var axes = this.get("axes");
        var calculatedTicksY1 = Utils.getTickValues(this.get("y1Domain"), this.get("ticksNumber"));
        var y1TickValues = this.get("y1TickValues") || this.get("tickValues") || calculatedTicksY1;
        var xScale = scales.scale("x");

        var tickFormat = function tickFormat(symbol, length, formatFn) {
            return function (d, i) {
                var value = _this.tickFormat(formatFn)(d);
                value = Utils.string.convertDashToEnDash(value);
                return symbol && i === length - 1 ? symbol + value : value;
            };
        };

        var xAxis = d3.svg.axis().scale(xScale).orient(this.get("xAxisOrient")).tickSize(this.get("xTickSize")).tickFormat(this.get("_xTickFormat")).ticks.apply(this, this.get("_xTicks"));

        var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y1TickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), y1TickValues.length, this.get("y1TickFormat")));

        axes.axis("x", xAxis);
        axes.axis("y1", yAxis);

        if (this.get("y2")) {
            var calculatedTicksY2 = Utils.getTickValues(this.get("y2Domain"), this.get("ticksNumber"));
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues") || calculatedTicksY2;

            axes.axis("y2", d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y2TickValues).tickFormat(tickFormat(this.get("y2TickSymbol"), y2TickValues.length, this.get("y2TickFormat"))));
        }
    },

    /**
     * @method buildScales
     * @desc Invoke the calculateDomain method and build all of the scales
     * @example
     *
     * chart.buildScales()
     *
     * @return undefined
     */
    buildScales: function buildScales() {
        this.calculateDomain();
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var yPadding = this.get("yPadding");

        var xScale = d3.time.scale().domain(this.get("xDomain")).rangeRound([yPadding, canvas.width() - yPadding - 1]);

        var y1TickValues = this.get("y1TickValues") || this.get("tickValues");
        var y1Domain = y1TickValues ? [d3.min(y1TickValues), d3.max(y1TickValues)] : this.get("y1Domain");
        var yScale = d3.scale.linear().domain(y1Domain).range([canvas.height(), 0]);

        scales.scale("x", xScale);
        scales.scale("y1", yScale);

        if (this.get("y2")) {
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues");
            var y2Domain = y2TickValues ? [d3.min(y2TickValues), d3.max(y2TickValues)] : this.get("y2Domain");
            scales.scale("y2", d3.scale.linear().domain(y2Domain).range([canvas.height(), 0]));
        }
    },

    /**
     * @method calculateDomain
     * @desc Takes the values in the datasets and calculates the domain, setting them as:
     * y1Domain, y2Domain, xDomain
     *
     * @example
     *
     * chart.calculateDomain()
     *
     * @return undefined
     */
    calculateDomain: function calculateDomain() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y1 = dataManager.get(y1DomainDataset);
        var y1Symmetrical = this.get("y1Symmetrical");
        var y1DataSet = [];
        var xDataSet = [];

        y1.forEach(function (dataset) {
            dataset.series.forEach(function (segment) {
                xDataSet.push(segment.date);
                y1DataSet.push(segment.value);
            });
        });

        var adjustedY1Domain = this.adjustYDomain(y1DataSet, y1Symmetrical);
        this.set("y1Domain", adjustedY1Domain);

        if (this.get("y2")) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2 = dataManager.get(y2DomainDataset);
            var y2Symmetrical = this.get("y2Symmetrical");
            var y2DataSet = [];

            y2.forEach(function (dataset) {
                dataset.series.forEach(function (segment) {
                    xDataSet.push(segment.date);
                    y2DataSet.push(segment.value);
                });
            });

            var adjustedY2Domain = this.adjustYDomain(y2DataSet, y2Symmetrical);
            this.set("y2Domain", adjustedY2Domain);
        }

        var adjustedXDomain = this.adjustXDomain(xDataSet);

        this.set("xDomain", adjustedXDomain);
    },

    /**
     * @method  adjustXDomain
     * @desc    Calculate and return a buffer for the x domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustXDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustXDomain: function adjustXDomain(dataset) {
        // add buffer spacing between datapoints and axix
        var xAxisStart = this.get("xAxisStart");
        var xAxisBuffer = this.get("xAxisBuffer");
        var xAxisEnd = this.get("xAxisEnd");

        var extent = d3.extent(dataset);

        if (this.get("xAxisStart")) {
            extent[0] = xAxisStart;
        }

        if (this.get("xAxisEnd")) {
            extent[1] = xAxisEnd;
        }

        if (!xAxisBuffer) {
            return extent;
        }

        if (xAxisBuffer.start) {
            extent[0] = this.helperXBuffer(extent[0], xAxisBuffer.start);
        }

        if (xAxisBuffer.end) {
            extent[1] = this.helperXBuffer(extent[1], xAxisBuffer.end);
        }

        return extent;
    },

    /**
     * @method  adjustYDomain
     * @desc    Calculate and return a buffer for the y domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustYDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustYDomain: function adjustYDomain(dataset, symmetrical) {
        // add buffer spacing between datapoints and axix
        var extent = d3.extent(dataset);
        var range = extent[1] - extent[0];
        var minMagnitude = this.getMagnitude(extent[0]);
        var maxMagnitude = this.getMagnitude(extent[1]);
        var setLowerBoundZero = extent[0] >= 0 && minMagnitude < maxMagnitude && range > Math.abs(extent[0]);
        var lowerBound = setLowerBoundZero ? 0 : Math.floor(extent[0] - range * 0.05);
        lowerBound = extent[0] < 0 && minMagnitude < maxMagnitude ? extent[0] : lowerBound;
        var adjusted = [lowerBound, Math.ceil(extent[1] + range * 0.05)];
        if (symmetrical) {
            return this.makeSymmetrical(adjusted);
        }

        return adjusted;
    },

    getMagnitude: function getMagnitude(number) {
        return Math.log(Math.abs(number)) * Math.LOG10E + 1 | 0;
    },

    /**
     * @method getMargins
     * @desc Calculate and return the margins for the chart
     *
     * @example
     *
     * var margins = chart.getMargins();
     * var leftMargin = margins.left;
     * @return {Object}
     */
    getMargins: function getMargins() {
        var y1AxisOrient = this.get("y1AxisOrient");
        var y2AxisOrient = this.get("y2AxisOrient");
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
        var yAxesSpacing = this.get("yAxesSpacing");
        var margin = {
            top: 5,
            right: 0,
            bottom: 25,
            left: yTickSize + yAxesLabelWidth
        };

        if (this.get("y2")) {
            if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                margin.left = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
            } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                margin.right = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
                margin.left = 0;
            } else {
                margin.right = yTickSize + yAxesLabelWidth;
            }
        } else if (y1AxisOrient === "right") {
            margin.right = yTickSize + yAxesLabelWidth;
            margin.left = 0;
        }

        if (this.get("xAxisOrient") === "top") {
            margin.top = 30;
            margin.bottom = 0;
        } else {
            margin.top = 5;
            margin.bottom = this.get("xLabels") ? 45 : 35;
        }

        return margin;
    },

    /**
     * @method checkBreakpoints
     * @desc Checks if a set breakpoint has been met with the grid and invokes the
     * redoCanvas method if so
     * @param {Number} newValue
     * @param {Number} oldValue
     *
     * @example
     *  canvas.watch("outerWidth", function (newValue, oldValue) {
            this.checkBreakpoints(newValue, oldValue);
        }.bind(this));
      * @return undefined
     */
    checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
        var dw = newValue > oldValue;
        var breakpoint = this.get("breakpoint");
        if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
            this.redoCanvas();
        }
    },

    /**
     * @method setCanvasTemplate
     * @desc set the canvas template which is used in beforeCanvas from grid core
     * @param {Number} width
     *
     * @example
     *
     *  this.setCanvasTemplate(selection[0][0].offsetWidth);
     * @return undefined
     */
    setCanvasTemplate: function setCanvasTemplate(width) {
        var template;
        if (this.get("legend")) {
            if (width > this.get("breakpoint")) {
                template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
            } else {
                template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
            }
        }

        this.set("canvasTemplate", template);
    },

    /**
     * @method setClipPathId
     * @desc set clipPath ID which is used in beforeCanvas from grid core
     *
     * @example
     *
     *  this.setClipPathId
     * @return undefined
     */
    setClipPathId: function setClipPathId() {
        var id = Math.floor(Math.random() * 90000) + 10000;
        if (this.get('clipPathId') == null) {
            this.set("clipPathId", "mbc-time-series-clip-mask--" + id);
        }
    },

    // @IMPLEMENTED
    // Do something before canvas render.
    beforeCanvas: function beforeCanvas(selection) {
        this.setCanvasTemplate(selection[0][0].offsetWidth);
        this.setClipPathId();
    },

    /**
     * @method redoCanvas
     * @desc Removes the canvas, resets the template, and then re-renders the canvas
     *
     * @example
     *
     *  chart.redoCanvas
     * @return undefined
     */
    redoCanvas: function redoCanvas() {
        var canvas = this.get("canvas");
        canvas.remove();
        this.set("initialized", false);

        this.setCanvasTemplate();
        this._createCanvas();
    },

    /**
     * Reloads all the chart's data.
     * @param {Object} dataset Initial dataset object.
     */
    data: function data(dataset) {
        this.get("data").clean();
        this.setData(dataset);
        this.redoCanvas();
        this.update();
        return this;
    },

    /**
     * @method add
     * @description Add a series to the chart
      * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
     * @param {String} groupName - name of the dataset group
     * @example
     * chart.add({
     *      name: "Apple Inc.",
     *      values: [{}, {}]
     * })
     * @return {this}
     */
    add: function add(name, series, groupName) {
        this.get("data").set(name, series, groupName);

        this.redoCanvas();
        this.update();

        return this;
    },

    /**
     * @method remove
     * @description Removes a series from the chart.
     * @param {String} seriesName Name of the series to remove from the chart.
     * @return {this}
     */
    remove: function remove(seriesName) {
        this.get("data").remove(seriesName);
        this.redoCanvas();
        this.update();
        return this;
    }

});

module.exports = TimeSeriesLineChart;

/***/ })

/******/ });
});